import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetNews = () => {
  const get = useTypedApiClient({
    path: '/le-connect/news',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/news'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
